export default __webpack_public_path__ + "static/media/saab.a5b254d9.svg";